import { Box, CardContent, Divider } from "@mui/material";
import { AboutIcon, Card, Grid, Spacer, Typography } from "../style";
import { Home, Person, Settings } from "@mui/icons-material";

function ClienteCard({ cliente, legale }) {
  if (!cliente) {
    return;
  }
  const persona = legale
    ? cliente.ragioneSociale && cliente.ragioneSociale
    : cliente.cognome && cliente.nome
    ? `${cliente.cognome} ${cliente.nome}`
    : "";

  return (
    <Card>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Cliente
        </Typography>

        <Spacer mb={4} />

        <Grid container direction="row" alignItems="center" mb={2}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap="2"
          >
            <AboutIcon>
              <Person />
            </AboutIcon>

            <Typography>{persona}</Typography>
          </Box>
        </Grid>
        <Grid container direction="row" alignItems="center" mb={2}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap="2"
          >
            <AboutIcon>
              <Home />
            </AboutIcon>
            {cliente.slResIndirizzoVia &&
              cliente.slResIndirizzo &&
              cliente.slResCivico &&
              cliente.slResProvincia &&
              `${cliente.slResIndirizzoVia} ${cliente.slResIndirizzo},
              ${cliente.slResCivico}, ${cliente.slResProvincia}`}
          </Box>
        </Grid>
        <Grid container direction="row" alignItems="center" mb={2}>
          <Grid item>
            <AboutIcon>
              <Settings />
            </AboutIcon>
          </Grid>
          <Grid item>{cliente.piva && `P.IVA: ${cliente.piva}`}</Grid>
        </Grid>
      </CardContent>
      <Divider />
    </Card>
  );
}

export default ClienteCard;
